import { useContext } from "react"
import { Box } from "@chakra-ui/react"
import { Tooltip } from "@hydrologiq/shared/chakra/Tooltip"
import { Panel } from "@xyflow/react"
import { RealtimeContext } from "../providers/SystemProvider"

/**
 * Small coloured dot shown in the top-left corner of the ReactFlow canvas when
 * the Supabase Realtime connection is not healthy. Hidden when connected.
 */
const RealtimeStatusIndicator = () => {
  const { status } = useContext(RealtimeContext)

  // Don't render anything when connected — this is the normal happy-path state.
  if (status === "connected") return null

  const isReconnecting = status === "reconnecting"
  const color = isReconnecting ? "orange.400" : "red.500"
  const label = isReconnecting
    ? "Realtime reconnecting — changes from other users may be delayed"
    : "Realtime disconnected — changes from other users will not appear until reconnected"

  return (
    <Panel position="top-left">
      <Tooltip content={label} positioning={{ placement: "bottom-start" }}>
        <Box
          width="10px"
          height="10px"
          borderRadius="full"
          bg={color}
          boxShadow="0 0 0 2px white"
          cursor="help"
          aria-label={label}
        />
      </Tooltip>
    </Panel>
  )
}

export default RealtimeStatusIndicator
